import { render, staticRenderFns } from "./Affiliations.vue?vue&type=template&id=5fb32bce&"
import script from "./Affiliations.vue?vue&type=script&lang=js&"
export * from "./Affiliations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports